import { inject } from "@angular/core";
import { AuthService, ChildQuery, ChildService, MemberQuery } from "@fgb/core";
import { map, switchMap } from "rxjs/operators";

export const canMatchGuardian = () => {
    const authService = inject(AuthService);
    const childService = inject(ChildService);
    const childQuery = inject(ChildQuery);
    
    if( authService.isAuthenticated() ){
        const memberQuery = inject(MemberQuery);

        if( memberQuery.getUserContext().status !== 1 ){
            return childService.fetchGuardian().pipe(
              switchMap(() => childQuery.selectGuardian()),
              map(guardian => !!guardian)
            );
        }

    }
        
    return false;
}